const testing = false
const testingSiteName = 'spree-public-test'
const testingMessage = undefined
const testingAppId = '49b5fae0-46c6-41bc-be50-393f94a69ede'
const passcode = undefined

export { testing, testingSiteName, testingMessage, testingAppId, passcode }
